import React, { useEffect, useState } from "react";
import { Form, Input, Spin, Modal, InputNumber } from "antd";
import { FormConfig } from "../../../../../shared/config/GlobalConfig";
import ReferenciasApi from "../../../../referencias/api/ReferenciasApi";
import Utils from "../../../../../shared/helpers/utils";
import CuitFormItem from '../../../../../shared/components/cuitFormItem';
import ReferenciaSelectFormItem from "../../../../../shared/components/referenciaSelectFormItem";
import CampoObligatorio from "../../../../../shared/components/campoObligatorio";

const FormItem = Form.Item;

const AnexoIContratistaModal = props => {
  const [ciius, setCiius] = useState([]);
  const [working, setWorking] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    ReferenciasApi.GetTabla("PUBLICACIONES.CIIU").then((response) => { setCiius(response); })
  }, []);

  useEffect(() => {
    if(props.visible === true){ form.resetFields(); }
  }, [props.visible]);

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        props.onOk({ 
          Hash: props.contratista ? props.contratista.Hash : Utils.generateHash(), 
          ...values });
      });
  }

  return (
    <Modal 
      title={`${props.contratista ? 'Editar' : 'Agregar'} Contratista`}
      width="60%"
      visible={ props.visible }
      onOk={ handleOk }
      onCancel={ props.onCancel }
    >
      <Spin spinning={ working }>
        <Form
          { ...FormConfig.DefaultLayout }
          form={ form }
          name="formulario"
          initialValues={{ ...props.contratista }}
          scrollToFirstError
        >
          { props.contratista?.IdContratista ? <FormItem name="IdContratista" label="IdContratista" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          <CuitFormItem name="Cuit" label="Cuit" rules={ [...FormConfig.DefaultRules] } />

          <ReferenciaSelectFormItem name="Ciiu" label="Ciiu" 
            rules={ FormConfig.DefaultRules } 
            tabla={ ciius }
          />

          <FormItem name="CantidadTrabajadores" label="Cantidad Trabajadores" rules={ FormConfig.DefaultRules }>
            <InputNumber min={ 0 } style={ { width: '100%' } }/>
          </FormItem>
          
          <CampoObligatorio/>
          
        </Form>
      </Spin>
    </Modal>
  );
}

export default AnexoIContratistaModal;